import type { SupportedLocale } from "./routing";

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQContent {
  title: string;
  titleHighlight: string;
  subtitle: string;
  items: FAQItem[];
}

export const faqContent: Record<SupportedLocale, FAQContent> = {
  et: {
    title: "Korduma kippuvad",
    titleHighlight: "küsimused",
    subtitle: "Vastused sagedastele küsimustele sündmuste korraldamise kohta.",
    items: [
      {
        question: "Kui kaua ette tuleks alustada sündmuse planeerimist?",
        answer:
          "See sõltub sündmuse suurusest ja keerukusest. Pulmade puhul soovitame alustada vähemalt 8-12 kuud ette, väiksemate sündmuste puhul piisab sageli 2-3 kuust. Ettevõtte sündmused vajavad tavaliselt 3-6 kuud planeerimist.",
      },
      {
        question: "Milline on keskmine eelarve eri tüüpi sündmustele?",
        answer:
          "Eelarve sõltub külaliste arvust, asukohast ja soovitud lahendusest. Väiksemad eraüritused algavad sageli 2000 eurost, pulmade ja ettevõtte sündmuste eelarve kujuneb tavaliselt personaalse pakkumise alusel.",
      },
      {
        question: "Kas pakute teenuseid ka väljaspool Tallinnat?",
        answer:
          "Jah. Korraldame sündmusi üle Eesti ning oleme töötanud Tallinnas, Tartus, Pärnus, Kuressaares ja paljudes teistes paikades.",
      },
      {
        question: "Kas saame kasutada enda valitud teenusepakkujaid?",
        answer:
          "Jah. Teeme hea meelega koostööd teie valitud partneritega ning koordineerime nad terviklikku sündmuseplaani. Vajadusel pakume ka enda usaldusväärsete partnerite võrgustikku.",
      },
    ],
  },
  en: {
    title: "Frequently asked",
    titleHighlight: "questions",
    subtitle: "Answers to common questions about planning an event with us.",
    items: [
      {
        question: "How far in advance should we start planning an event?",
        answer:
          "It depends on the size and complexity of the event. For weddings, we recommend starting at least 8-12 months ahead. Smaller events often need 2-3 months, while corporate events usually require 3-6 months of planning.",
      },
      {
        question: "What is the typical budget for different types of events?",
        answer:
          "The budget depends on guest count, location and the desired production level. Smaller private events often start around 2,000 euros, while weddings and corporate events are normally priced through a tailored proposal.",
      },
      {
        question: "Do you organize events outside Tallinn?",
        answer:
          "Yes. We organize events throughout Estonia and have worked in Tallinn, Tartu, Pärnu, Kuressaare and many other locations.",
      },
      {
        question: "Can we use suppliers we have selected ourselves?",
        answer:
          "Yes. We are happy to work with your preferred suppliers and coordinate them as part of the complete event plan. We can also recommend partners from our trusted network when needed.",
      },
    ],
  },
  ru: {
    title: "Часто задаваемые",
    titleHighlight: "вопросы",
    subtitle: "Ответы на распространенные вопросы об организации мероприятий.",
    items: [
      {
        question: "За сколько времени следует начинать подготовку мероприятия?",
        answer:
          "Это зависит от масштаба и сложности мероприятия. Подготовку свадьбы рекомендуем начинать минимум за 8-12 месяцев. Для небольших мероприятий часто достаточно 2-3 месяцев, а корпоративные события обычно требуют 3-6 месяцев планирования.",
      },
      {
        question: "Каков обычный бюджет для разных типов мероприятий?",
        answer:
          "Бюджет зависит от количества гостей, места проведения и желаемого уровня программы. Небольшие частные мероприятия часто начинаются от 2000 евро, а стоимость свадеб и корпоративных событий рассчитывается в индивидуальном предложении.",
      },
      {
        question: "Организуете ли вы мероприятия за пределами Таллинна?",
        answer:
          "Да. Мы организуем мероприятия по всей Эстонии и работали в Таллинне, Тарту, Пярну, Курессааре и многих других местах.",
      },
      {
        question: "Можем ли мы привлечь выбранных нами поставщиков?",
        answer:
          "Да. Мы с удовольствием работаем с выбранными вами партнерами и координируем их в рамках общего плана мероприятия. При необходимости мы также предложим специалистов из нашей проверенной сети.",
      },
    ],
  },
};
